import React, { useEffect, useState } from 'react';
import './Tips.scss';
import { useTranslation } from 'react-i18next';
import { Col, Row, Skeleton } from 'antd';
import { fetchTips } from 'services/laundryTipsService';
import type { CustomPageDTO } from 'types/dto/tips';

const Tips = () => {
  const { t, i18n } = useTranslation('tips');
  const { t: tCommon } = useTranslation('common');

  const [tipsData, setTipsData] = useState<CustomPageDTO>();
  const [isLoading, setIsLoading] = useState(true);
  const [loadError, setLoadError] = useState(false);

  const isEnglish = i18n.language === 'en';

  useEffect(() => {
    const initData = async () => {
      try {
        setIsLoading(true);
        setLoadError(false);
        const response: CustomPageDTO = await fetchTips();
        setTipsData(response);
      } catch (err) {
        setLoadError(true);
      } finally {
        setIsLoading(false);
      }
    };

    initData();
  }, [i18n.language]);

  const getCurrentContent = () => {
    if (!tipsData) return '';
    return isEnglish ? tipsData.content?.en || '' : tipsData.content?.zh || '';
  };

  const getCurrentTitle = () => {
    if (!tipsData) return '';
    return isEnglish ? tipsData.title.en : tipsData.title.zh;
  };

  return (
    <div className="tips-container">
      <div className="tips-content">
        <div className="tips-section">
          <div className="tips-title">{t('title')}</div>

          {isLoading && (
            <div>
              <Skeleton active paragraph={{ rows: 4 }} />
            </div>
          )}

          {/* Show error alert if loading failed */}
          {loadError && !isLoading && (
            <div>{tCommon('error.loadDataError')}</div>
          )}

          {!isLoading && !loadError && tipsData && (
            <Row gutter={24} className="tips-info">
              <Col sm={8} xs={24}>
                <img
                  src={isEnglish ? tipsData.cover.en : tipsData.cover.zh}
                />
              </Col>
              <Col sm={16} xs={24}>
                <div className="tips-info-content">
                  <div
                    className="tips-text-title"
                    style={{
                      whiteSpace: 'pre-line',
                      marginBottom: '16px'
                    }}
                  >
                    {getCurrentTitle()}
                  </div>
                  <div
                    className="tips-text-content"
                    dangerouslySetInnerHTML={{ __html: getCurrentContent() }}
                  />
                </div>
              </Col>
            </Row>
          )}
        </div>
      </div>
    </div>
  );
};

export default Tips;
